

export enum Suit {
	Clubs    = "Clubs",
	Diamonds = "Diamonds",
	Hearts   = "Hearts",
	Spades   = "Spades",
	Joker    = "Joker"
}


export class Card {
	private static highRanks : IntLookup = {
		0:  "Joker",
		1:  "Ace",
		11: "Babe",
		12: "Queen",
		13: "King"
	}

	private static suitGraphics : StringLookup = {
		"Clubs":    "&clubs;",
		"Diamonds": "&diams;",
		"Hearts":   "&hearts;",
		"Spades":   "&spades;",
		"Joker":    ""
	} 


	public suit : Suit
	public rank : number // [1-13]


	constructor (suit: Suit, rank:number) {
		this.suit = suit
		this.rank = rank
	}


	public static Hydrate (data:any) : Card {
		return new Card(data.suit, data.rank)
	}


	public static FromCode (code:string) : Card|null {
		const parts : string[] = code.split("-")
		if (parts.length != 2)
			return null

		var rank : number = Number.parseInt(parts[0])
		var suit : string = parts[1]

		return new Card(suit as Suit, rank)
	}


	public Code () : string {
		return `${this.rank}-${this.suit}`
	}


	public toString () : string {
		if (this.suit == Suit.Joker)
			return "Joker"

		let rank : string = this.rank.toString()
		if (this.rank > 10) {
			rank = Card.highRanks[this.rank]
		}

		return `${rank} of ${this.suit}`
	}


	public IsEven () : boolean {
		return this.rank%2 === 0
	}


	public SuitGraphic () : string {
		return Card.suitGraphics[this.suit]
	}


	public ShortRank () : string {
		if (this.suit == Suit.Joker)
			return "J"

		if (this.rank > 10)
			return Card.highRanks[this.rank].substring(0,1)
		
		return this.rank.toString()
	}


	public Color () : string {
		if (this.suit == Suit.Hearts || this.suit == Suit.Diamonds)
			return "red";
		return "black";
	}
}



export class Deck {
	public cards : Card[]


	constructor (cards:Card[]) {
		this.cards = cards
	}


	public static Hydrate (data:any) : Deck {
		return new Deck(
			data.cards.map( (c:any) => Card.Hydrate(c) )
		)
	}


	public static GenerateDeck (jokers : number) {
		let cards : Card[] = []

		for (const suit of [Suit.Diamonds, Suit.Diamonds, Suit.Hearts, Suit.Spades]) {
			for (const rank of [1,2,3,4,5,6,7,8,9,10,11,12,13]) {
				cards.push( new Card(suit, rank) )
			}
		}

		for (let j = 0; j < jokers; ++j) {
			cards.push( new Card(Suit.Joker, 0) )
		}

		return new Deck(cards)
	}


	public Scramble () : void {
		for (let i = this.cards.length-1 ; i > 0 ; --i) {
			let spoink = Math.floor(Math.random() * (i+1));
			[this.cards[i], this.cards[spoink]] = [this.cards[spoink], this.cards[i]]
		}
	}


	public Sort () : void {
		this.cards.sort( (a,b) => {
			if (a.suit == Suit.Joker)
				return 1
			if (b.suit == Suit.Joker)
				return -1
			
			return b.rank - a.rank 
		})
	}


	public TakeCard () : Card|undefined {
		const card = this.cards.pop()
		return card
	}


	public TakeCardByCode (code:string) : Card|null {
		for (const card of this.cards) {
			if (card.Code() == code)
				return card
		}
		return null
	}


	public AddCard (card:Card) : void {
		this.cards.push(card)
	}


	public RemoveCard (card:Card) : boolean {
		const index = this.cards.findIndex( c => c.Code() == card.Code() )
		if (index == -1)
			return false
		this.cards.splice(index, 1)
		return true
	}


	public LastPlayed () : Card|undefined {
		return this.cards[ this.cards.length-1 ]
	}


	public toString () : string {
		return this.cards.map(c => c.toString()).join("\n")
	}
}


interface IntLookup {
  [key: number]: string
}


interface StringLookup {
  [key: string]: string
}